import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import React, { useCallback, useMemo, useState } from 'react'
import { useLocalState } from '../../../../shared/UseLocalState'
import { ExamApi, HorseApi, Person, PersonApi } from '../../../../api'
import { authState } from '../../../../state/Auth.state'
import { Loading } from '../../../loading/Loading'
import { DataTable } from 'primereact/datatable'
import { registrationState } from '../Registration.state'
import { Column } from 'primereact/column'
import { appState } from '../../../../state/App.state'
import {
  BookedService,
  ServiceDto,
  Show,
  Starter,
  StarterExmsDto,
  StarterResponse,
  BookedExamResponse,
  StarterDto,
  StarterResponseFromJSON
} from '../../../../api'
import { HorseByRegId } from '../../../../shared/HorseByRegId'
import { ExamByStarter, PersonByRegId } from '../../../../shared/RiderByRegId'

import { actualShowState } from '../../../../state/ActualShow.state'
import { horsesState } from '../../../../state/Horses.state'
import { ServiceSelectionPanel } from './ServiceSelectionPanel'

export const UpdateScreen = () => {
  /* STATE */
  const user = useLocalState<Person | null>(authState.user$, authState.user$.value)
  const selectedUser = useLocalState<Person | null>(registrationState.selectedRider$, registrationState.selectedRider$.value)
  const selectedStarter = useLocalState<Starter | null>(registrationState.selectedStarter$, registrationState.selectedStarter$.value)
  const [regId, setRegId] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const additionalUsers = useLocalState<Person[]>(registrationState.additionalRiders$, registrationState.additionalRiders$.value)

  const actualShow = useLocalState<Show | undefined>(actualShowState.actualShow$, actualShowState.actualShow$.value)
  const starters = useLocalState<Starter[]>(actualShowState.actualShowStarters$, actualShowState.actualShowStarters$.value)
  const actualShowBookedServices = useLocalState(actualShowState.actualShowBookedServices$, actualShowState.actualShowBookedServices$.value)
  const showServices = useLocalState<ServiceDto[]>(actualShowState.actualShowServices$, actualShowState.actualShowServices$.value)

  /* DERIVED STATE */
  const userOptions: Person[] = useMemo(() => (user ? [user, ...additionalUsers] : additionalUsers), [user, additionalUsers])

  /* LOGIC */
  const getRiderByRegId = useCallback(() => {
    appState.addToast('Reiter mit RegId ' + ' xx nicht gefunden', 'error')
    if ([user, ...additionalUsers]?.some((horse) => horse?.registerId === regId))
      return appState.addToast('Reiter bereits in Tabelle!', 'warning')
    setLoading(true)
    new PersonApi(authState.apicfg())
      .apiPersonRegisterRegisterIdGet({
        registerId: regId
      })
      .then((p) => {
        appState.addToast('Reiter gefunden: ' + p?.firstName + ' ' + p?.lastName, 'info')
        registrationState.additionalRiders$.next([...registrationState.additionalRiders$.value, p])
        registrationState.selectedRider$.next(p)
      })
      .catch(() => {
        appState.addToast('Reiter mit RegId ' + regId + ' nicht gefunden', 'error')
      })
      .finally(() => setLoading(false))
  }, [regId])

  /* TEMPLATE */
  return (
    <>
      <Loading loading={loading} />

      {starters?.length < 1 && <h3>Sie haben noch keine Startnummer gebucht!</h3>}
      {starters?.length > 0 && (
        <>
          <h3>
            Ihre schon gebuchten Startnummern. Zum nachnennen oder stornieren bitte eine Starnummer auswählen. <br />
            {}
          </h3>

          <DataTable
            value={starters}
            showSelectAll={false}
            showHeaders={false}
            //value={userOptions}
            selectionMode={'single'}
            selection={selectedStarter}
            onSelectionChange={async (e) => {
              try {
                const starter = (e?.value as Starter) ?? null
                if (starter) {
                  setLoading(true)
                  const horseId = starter?.horseRegisterId
                  const riderId = starter?.riderRegisterId
                  // fetch horse
                  const horse = await new HorseApi(authState.apicfg()).apiHorseRegisterIdGet({ registerId: `${horseId ?? -1}` })
                  // only if horse not already in list
                  if (!horsesState.horses$.value?.some((h) => h?.registerId === horseId)) {
                    registrationState.additionalHorses$.next([
                      ...(registrationState.additionalHorses$.value?.filter((h) => h?.registerId !== horseId) ?? []),
                      horse
                    ])
                  }
                  // fetch rider
                  const rider = await new PersonApi(authState.apicfg()).apiPersonRegisterRegisterIdGet({ registerId: `${riderId ?? -1}` })
                  //if (authState?.user$?.value?.registerId !== riderId) {
                  registrationState.additionalRiders$.next([
                    ...(registrationState.additionalRiders$.value?.filter((r) => r?.registerId !== riderId) ?? []),
                    rider
                  ])
                  //}
                  // get exams
                  const exams = actualShowState.actualShowExams$.value?.filter((e) =>
                    (starter as any)?.bookedExams?.some((e2: any) => e?.id === e2?.examId && !e2?.cancelDate)
                  )
                  // set state
                  registrationState.selectedHorse$.next(horse)
                  registrationState.selectedRider$.next(rider)
                  registrationState.selectedExams$.next(exams)
                  console.log(starter)
                  registrationState.gweGateExam$.next(
                    (starter as any)?.bookedExams?.reduce((no: number, e2: StarterExmsDto) => (e2?.gweGateExam ? e2?.examId : no), -1)
                  )
                } else {
                  registrationState.selectedHorse$.next(null)
                  registrationState.selectedRider$.next(null)
                  registrationState.selectedExams$.next([])
                  registrationState.gweGateExam$.next(-1)
                }
                registrationState.selectedStarter$.next(starter)
              } catch (e) {
                console.error(e)
              } finally {
                setLoading(false)
              }
            }}
            emptyMessage='Keine Buchungen!'
          >
            <Column selectionMode='single' bodyStyle={{ width: '3rem' }} />
            <Column header='StartNr.' body={(starter: Starter) => starter?.startNo} />
            <Column header='Pferd' body={(starter: Starter) => <HorseByRegId regId={starter?.horseRegisterId} />} />
            <Column header='Reiter' body={(starter: Starter) => <PersonByRegId regId={starter?.riderRegisterId} />} />

            <Column
              header='Prüfungen'
              body={(starter: StarterResponse) =>
                starter?.bookedExams ? <ExamByStarter bookedExams={starter?.bookedExams} /> : <span>Keine Prüfungen</span>
              }
            />
          </DataTable>
        </>
      )}

      {/* Gebuchte Services Typ N – gruppiert nach Startnummer */}
      {starters?.length > 0 && (
        <div style={{ marginTop: '1.5rem' }}>
          <h3>Gebuchte Services je Startnummer</h3>
          {starters.map((starter) => {
            const starterServices = actualShowBookedServices?.filter(
              (bs) =>
                bs?.starterId === starter?.id &&
                showServices?.find((so) => so?.id === bs?.serviceId)?.type === 'N'
            )
            if (!starterServices?.length) return null
            return (
              <div key={starter?.id} style={{ marginBottom: '1rem' }}>
                <p style={{ fontWeight: 'bold', margin: '0.5rem 0 0.25rem 0' }}>
                  Nr. {starter?.startNo} – <HorseByRegId regId={starter?.horseRegisterId} /> / <PersonByRegId regId={starter?.riderRegisterId} />
                </p>
                <DataTable value={starterServices} style={{ width: '100%' }}>
                  <Column
                    header='Service'
                    body={(service: BookedService) => showServices?.find((s) => s?.id === service?.serviceId)?.name}
                  />
                  <Column
                    header='Menge'
                    headerStyle={{ width: '4rem', textAlign: 'right' }}
                    bodyStyle={{ width: '4rem', textAlign: 'right' }}
                    body={(service: BookedService) => service?.quantity}
                  />
                  <Column
                    header='Preis'
                    headerStyle={{ width: '5rem', textAlign: 'right' }}
                    bodyStyle={{ width: '5rem', textAlign: 'right', whiteSpace: 'nowrap' }}
                    body={(service: BookedService) => service?.totalPrice?.toFixed(2).replace('.', ',') + ' €'}
                  />
                </DataTable>
              </div>
            )
          })}
        </div>
      )}

      {/* Services Typ N zur Auswahl – nur wenn eine Startnummer ausgewählt ist */}
      {selectedStarter && <ServiceSelectionPanel types={['N']} title='Services zur ausgewählten Startnummer:' />}
    </>
  )
}
